import React from "react";

type BadgeExplanationContainerProps = React.ComponentProps<"div">;

export const BadgeExplanationHeaderContainer = ({
  children,
}: BadgeExplanationContainerProps) => {
  return <div className={"flex items-center gap-2 mt-4"}>{children}</div>;
};
